(function() {
    'use strict';

    angular
        .module('MW.ContactManager.OutreachService', [
            'Configuration'
        ])
        .service('OutreachService', [
            '$http',
            '$q',
            'EMAIL_DOMAIN_URL',
            function($http, $q, EMAIL_DOMAIN_URL) {
                var headerConfig = {
                    headers: {
                        'X-Client-Name': 'icm-web'
                    }
                };

                this.getLastDayCount = function getLastDayCount(date, distributionId) {

                    if(distributionId) {
                        return $http.get(EMAIL_DOMAIN_URL + '/lastDayCount/' + date +'/'+ distributionId, headerConfig).then(function(response) {
                            return response.data.count;
                        });
                    } else {
                        return $http.get(EMAIL_DOMAIN_URL + '/lastDayCount/' + date, headerConfig).then(function(response) {
                            return response.data.count;
                        });
                    }
                };

                this.getEmailById = function getEmailById(emailId) {

                    return $http.get(EMAIL_DOMAIN_URL + '/' + emailId, headerConfig).then(function(response) {
                        return response.data[0];
                    });
                };

                this.getOutreachStatsById = function getOutreachStatsById(distributionId) {

                    return $http.get(EMAIL_DOMAIN_URL + '/stats/' + distributionId, headerConfig).then(function(response) {
                        return response.data;
                    });
                };

                this.outreach = function outreach(payload, fileArray) {
                    var config = {
                        headers: {
                            'X-Client-Name': 'icm-web',
                            'Content-Type': undefined
                        }
                    };

                    var formData = new FormData(),
                        defer = $q.defer();

                    formData.append('model', angular.toJson(payload));

                    if(fileArray && fileArray.length) {
                        for (var i = 0; i < fileArray.length; i++) {
                            //add each file to the form data and iteratively name them
                            formData.append('file' + i, fileArray[i]);
                        }
                    }

                    $http.post(EMAIL_DOMAIN_URL + '/send', formData, config).then(function(response) {
                        defer.resolve(response.data);
                    }).catch(function(response) {
                        defer.reject(response.data);
                    });

                    return defer.promise;
                };

                this.getAllEmails = function getAllEmails(payload) {
                    var defer = $q.defer();

                    $http.post(EMAIL_DOMAIN_URL + '/v2/getAllEmails', payload, headerConfig).then(function(response) {
                        defer.resolve(response.data);
                    }).catch(function(response) {
                        defer.reject(response.data);
                    });

                    return defer.promise;
                };

                this.deleteOutreachEmail = function deleteOutreachEmail(distributionIdArray) {
                    var defer = $q.defer(),
                        payload = {
                            distributionIdArray: distributionIdArray
                        };

                    $http.post(EMAIL_DOMAIN_URL + '/deleteOutreachEmail', payload, headerConfig).then(function(response) {
                        defer.resolve(response.data);
                    }).catch(function(response) {
                        defer.reject(response.data);
                    });

                    return defer.promise;
                };

                this.outreachUpdate = function outreachUpdate(payload, fileArray) {
                    var formData = new FormData(),
                        defer = $q.defer(),
                        config = {
                            headers: {
                                'X-Client-Name': 'icm-web',
                                'Content-Type': undefined
                            }
                        };

                    formData.append('model', angular.toJson(payload));

                    if(fileArray && fileArray.length) {
                        for (var i = 0; i < fileArray.length; i++) {
                            //add each file to the form data and iteratively name them
                            formData.append('file' + i, fileArray[i]);
                        }
                    }

                    $http.put(EMAIL_DOMAIN_URL + '/updateOutreachEmail', formData, config).then(function(response) {
                        defer.resolve(response.data);
                    }).catch(function(response) {
                        defer.reject(response.data);
                    });

                    return defer.promise;
                };
            }
        ]);
}());
